class WebCamPreviewManager {
  private Dictionary: Map<string, MediaStream> = new Map();

  /** deviceId que se pidió al abrir el stream de cada área (si se conoce). */
  private Requested: Map<string, string> = new Map();

  constructor() {}

  /**
   * Stream cacheado del área. Con `deviceId`, un stream abierto para OTRA
   * cámara se libera y devuelve null: al cambiar la fuente del área (p. ej.
   * Trust → OBS Virtual Camera) el cache por área devolvía la cámara vieja.
   */
  async getStream(id: string, deviceId?: string | null) {
    const source = this.Dictionary.get(id);
    if (!source || !source.active) {
      return null;
    }

    if (deviceId) {
      // Manda la cámara que el track realmente abrió; lo pedido solo cuenta
      // si el navegador no reporta el deviceId del track.
      const opened =
        source.getVideoTracks()[0]?.getSettings?.().deviceId ||
        this.Requested.get(id);

      if (opened && opened !== deviceId) {
        this.destroy(id);
        return null;
      }
    }

    return source;
  }

  setStream(id: string, stream: MediaStream, deviceId?: string | null) {
    this.Dictionary.set(id, stream);
    if (deviceId) {
      this.Requested.set(id, deviceId);
    } else {
      this.Requested.delete(id);
    }
  }

  destroy(id?: string) {
    if (id) {
      const stream = this.Dictionary.get(id);
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        this.Dictionary.delete(id);
      }
      this.Requested.delete(id);
    } else {
      this.Dictionary.forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
      this.Dictionary.clear();
      this.Requested.clear();
    }
  }
}

export default new WebCamPreviewManager();
